import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const CobrarIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M19.2105 12.9387V11.2667C19.2105 10.46 18.5 9.8 17.6316 9.8H6.57895C5.70263 9.8 5 10.46 5 11.2667V21.5333C5 22.34 5.70263 23 6.57895 23H17.6316C18.5 23 19.2105 22.34 19.2105 21.5333V19.8613C19.6763 19.6047 20 19.1427 20 18.6V14.2C20 13.6573 19.6763 13.1953 19.2105 12.9387ZM18.4211 14.2V18.6H12.8947V14.2H18.4211ZM6.57895 21.5333V11.2667H17.6316V12.7333H12.8947C12.0263 12.7333 11.3158 13.3933 11.3158 14.2V18.6C11.3158 19.4067 12.0263 20.0667 12.8947 20.0667H17.6316V21.5333H6.57895Z"
            fill="#222"
          />
          <path
            d="M15.2632 17.5C15.9172 17.5 16.4474 17.0075 16.4474 16.4 16.4474 15.7925 15.9172 15.3 15.2632 15.3 14.6091 15.3 14.0789 15.7925 14.0789 16.4 14.0789 17.0075 14.6091 17.5 15.2632 17.5zM13.3846 1V6.99133L16.1462 4.366 17.2308 5.4 12.6154 9.8 8 5.4 9.08462 4.366 11.8462 6.99133V1H13.3846z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
